import React, { useState, useEffect } from "react";
import { firestore } from "../../firebase-config";
import { collection, getDocs } from "firebase/firestore";
import "../../styles/fetchNewsPage.css"; // Include style

const UserNewsAndEvents = () => {
  const [news, setNews] = useState([]);
  const [status, setStatus] = useState(""); // To track loading status (loading, error)

  // Firestore collection reference
  const newsCollection = collection(firestore, "news");

  // Fetch news from Firestore
  useEffect(() => {
    const fetchNews = async () => {
      setStatus("loading");
      try {
        const querySnapshot = await getDocs(newsCollection);
        const fetchedNews = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setNews(fetchedNews); // Update the news state with fetched data
        setStatus("success");
      } catch (err) {
        console.error("Failed to fetch news:", err);
        setStatus("error");
      }
    };

    fetchNews();
  }, []); // Fetch news only on component mount

  return (
    <div className="user-news-container">
      {/* <h2>News and Events</h2> */}

      {/* Display loading spinner or error message */}
      {status === "loading" && <p>Loading news and events...</p>}
      {status === "error" && (
        <p className="error-message">Error fetching news. Please try again later.</p>
      )}

      {/* List of news/events */}
      <div className="news-list">
        {news.length === 0 && status === "success" ? (
          <p>No news or events available</p>
        ) : (
          news.map((item) => (
            <div key={item.id} className="news-item">
              <h3>{item.name}</h3>
              <p><strong>Date:</strong> {item.date}</p>
              <p>{item.description}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default UserNewsAndEvents;
